import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import Slider from "react-slick";
import './Slideshow.scss';

interface Data {
    paragraphById: {
        fieldBackgroundColor: string;
        fieldVarSlideDelayS: number;
        fieldFieldVarFadeDurationS: number;
        fieldImages: Array<{
            entity: Array<{
                fieldObjectImgMedia: Array<{
                    entity: Array<{
                        fieldMediaImage: Array<{
                            width: string;
                            height: string;
                            url: string;
                            targetId: string;
                            alt: string;
                            title: string;
                        }>;
                    }>;
                }>;
            }>;
        }>;
    }
}

class SlideshowQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentImageSlideShow {
          fieldBackgroundColor
          fieldVarSlideDelayS
          fieldFieldVarFadeDurationS
          fieldImages {
              entity {
                ... on ParagraphInnerImage {
                  fieldObjectImgMedia {
                      entity {
                        ... on MediaImage {
                          fieldMediaImage {
                            width
                            height
                            url
                            alt
                            title
                          }
                        }
                      }
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;

const Slideshow = ({id, markComponentLoadedAs}) => (
    <SlideshowQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            if (!field.fieldImages || !field.fieldImages.length) return null;

            let autoplaySpeed = 5000;
            let slideTransitionSpeed = 500;
            if (field.fieldVarSlideDelayS) autoplaySpeed = field.fieldVarSlideDelayS * 1000;
            if (field.fieldFieldVarFadeDurationS) slideTransitionSpeed = field.fieldFieldVarFadeDurationS * 1000;

            markComponentLoadedAs(id, true);

            return (
                <Slider swipeToSlide
                        slidesToShow={1}
                        fade
                        autoplay
                        autoplaySpeed={autoplaySpeed}
                        speed={slideTransitionSpeed}
                        pauseOnFocus={false}
                        pauseOnHover={false}>
                    {field.fieldImages.filter(component => component.entity && component.entity.fieldObjectImgMedia && component.entity.fieldObjectImgMedia.entity && component.entity.fieldObjectImgMedia.entity.fieldMediaImage && component.entity.fieldObjectImgMedia.entity.fieldMediaImage.url).map(component => (
                        <img key={`${id}_${component.entity.fieldObjectImgMedia.entity.fieldMediaImage.targetId}`}
                             alt={component.entity.fieldObjectImgMedia.entity.fieldMediaImage.alt || component.entity.fieldObjectImgMedia.entity.fieldMediaImage.title}
                             src={component.entity.fieldObjectImgMedia.entity.fieldMediaImage.url}
                        />
                    ))}
                </Slider>
            );
        }}
    </SlideshowQuery>
);

Slideshow.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default Slideshow;



// WEBPACK FOOTER //
// ./frontend/components/Slideshow/Slideshow.jsx